{
  "label": "utente",
  "button": {
    "delete": "Eliminare l’utente",
    "create": "Nuovo utente",
    "activate": "Attiva l'utente",
    "deactivate": "Disattiva l'utente",
    "disabled": {
      "unauthorized": "Permessi insufficienti per modificare questo utente"
    }
  },
  "empty": "Non è stato trovato nessun utente",
  "confirmRemove": {
    "title": "Eliminazione di un utente",
    "description": "L’utente selezionato \"{userName} {userFirstname}\" sarà eliminato"
  },
  "form": {
    "userIdentity": {
      "title": "Informazioni"
    },
    "userProfile": {
      "title": "Profilo"
    },
    "userGroups": {
      "title": "Gruppi",
      "selectAllLabel": "Seleziona tutti i gruppi"
    },
    "tabs": {
      "information": "Informazioni",
      "delegations": "Deleghe"
    },
    "delegations": {
      "selectOrganization": "Seleziona l’organizzazione",
      "selectProfile": "Seleziona il profilo",
      "noProfile": "Nessun profilo"
    }
  },
  "search": "Ricerca per cognome o nome",
  "userAccount": {
    "userInformations": {
      "title": "Informazioni utente"
    },
    "password": {
      "title": "Password"
    },
    "language": {
      "title": "Lingua",
      "activeDirectoryWarning": "Impossibile modificare la lingua perché active directory è attiva."
    },
    "certificate": {
      "title": "Certificato"
    },
    "instructions": {
      "informations": "Aggiorna qui le tue informazioni personali.",
      "email": "Gestisci il tuo indirizzo e-mail.",
      "phone": "Aggiungi il tuo numero di telefono.",
      "password": "Aggiorna la password.",
      "language": "Scegli la lingua che desideri utilizzare per LX Connect."
    },
    "forms": {
      "cancel": "Annulla",
      "certificateEmpty": "Nessun certificato",
      "certificateStatusDateFormat": "DD/MM/YYYY",
      "currentPassword": "Verifica della password attuale",
      "edit": "Modificare",
      "email": "E-mail",
      "firstName": "Nome",
      "generatedOn": "Generato il",
      "lastName": "Cognome",
      "login": "Login",
      "newPassword": "Nuova password",
      "organisationName": "Nome dell’organizzazione",
      "phoneNumber": "Numero di telefono",
      "profile": "Profilo",
      "requestNewCertificate": "Chiedere un nuovo certificato",
      "sectors": "Reti",
      "validate": "Conferma",
      "validFrom": "Valido a partire dal",
      "validTo": "Valido fino al"
    }
  },
  "table": {
    "column": {
      "lastName": "Cognome",
      "firstName": "Nome",
      "profile": "Profilo",
      "email": "E-mail",
      "groups": "Gruppi",
      "status": "Stato"
    }
  },
  "status": {
    "active": "Attivo",
    "inactive": "Inattivo"
  },
  "firstNameRequiredError": "Il nome è obbligatorio.",
  "lastNameRequiredError": "Il cognome è obbligatorio.",
  "loginRequiredError": "Il nome utente è obbligatorio.",
  "emailRequiredError": "L'e-mail è obbligatoria.",
  "languageError": "La lingua è obbligatoria.",
  "firstNameLengthError": "Lunghezza compresa tra 1 e 50 caratteri.",
  "firstNameFormatError": "Caratteri speciali consentiti tranne all'inizio o alla fine --> [ -_.'].",
  "lastNameLengthError": "Lunghezza compresa tra 1 e 50 caratteri.",
  "lastNameFormatError": "Caratteri speciali consentiti tranne all'inizio o alla fine --> [ -_.'].",
  "loginLengthError": "Lunghezza compresa tra 2 e 50 caratteri.",
  "loginFormatError": "Solo minuscole. Caratteri speciali consentiti tranne all'inizio o alla fine --> [!$%&'*+=?^`{'{'}{'|'}{'}'}~{'@'}_.-].",
  "emailFormatError": "Formato e-mail non valido.",
  "create": {
    "title": "Creazione utente",
    "information": "Informazioni",
    "saveButton": "Crea utente",
    "confirm": {
      "title": "Creazione utente"
    }
  },
  "lastName": "Cognome",
  "firstName": "Nome",
  "addUser": {
    "button": "Nuovo utente"
  },
  "login": "Nome utente",
  "email": "E-mail",
  "language": "Lingua",
  "profile": "Profilo",
  "profilePlaceholder": "Cerca per nome del profilo",
  "profileRequired": "Il profilo è obbligatorio.",
  "groups": "Gruppi",
  "groupsSearchPlaceholder": "Cerca per nome gruppo",
  "sectors": "Settori",
  "update": {
    "title": "Modifica utente",
    "confirm": {
      "title": "Modifica l'utente"
    }
  },
  "confirm": {
    "message": "Confermi l'annullamento dell'operazione? Tutti i dati non salvati andranno persi."
  },
  "filters": {
    "selectionQuickFilters": {
      "allUsers": "Tutti gli utenti",
      "selectedUsers": "Utenti selezionati",
      "unselectedUsers": "Utenti deselezionati"
    }
  },
  "read": {
    "title": "Visualizza utente"
  }
}
